import React from 'react';
import { fromDecimalNCR } from '../../../helpers/language';
import SelectWithSearch from './SelectWithSearch';
import { ISelectOption } from '../../../interface/form.interface';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import useTags from '../../../hooks/useTags';
import formLang from '../../../data/lang/form.lang';

type Props = {
    name: string,
    handleBlur: (e: any) => void,
    handleChange: (name: string | number, value: string | number) => void,
    errorMsg?: string | undefined,
    value: number,
    isRequired: boolean,
    disabled: boolean
}

const SelectStreet = ({ name, handleBlur, handleChange, errorMsg, value, isRequired, disabled }: Props) => {

    const { projectConfigState } = useProjectConfigContext();

    const generateTag = useTags();
    const streetLabel = generateTag(formLang, 'input-label.street');
    const defualtOption = generateTag(formLang, 'defualt-options.need-to-select');

    let streetsOp: ISelectOption[] = [{ value: -1, label: defualtOption }];

    if (
        projectConfigState.streets !== undefined ||
        projectConfigState.streets !== null ||
        projectConfigState.streets.length > 0
    ) {

        streetsOp = projectConfigState.streets.map(street => {
            return { label: fromDecimalNCR(street.name), value: street.id }
        });
    }

    //@ts-ignore
    const valueStr = streetsOp.find(option => option.value === value);

    return (
        <SelectWithSearch
            name={name}
            label={streetLabel}
            selects={streetsOp}
            disabled={disabled}
            isRequired={isRequired}
            handleBlur={handleBlur}
            handleChange={handleChange}
            value={valueStr ? valueStr : null}
            errorMsg={errorMsg}

        />
    );
}

export default SelectStreet; 